export enum eSortMode {
    ASC = "asc",
    DESC = "desc"
}